const state = {
    addressIsComplete: false,
    missingAddressParts: [],
}

const mutations = {
    SET_MISSING_PARTS(state, data) {
        state.missingAddressParts = data
    },
    SET_ADDRESS_STATUS(state, data) {
        state.addressIsComplete = data
    },
}

const actions = {
    setMissingParts({ commit }, data) {
        commit('SET_MISSING_PARTS', data)
    },
    setAddressStatus({ commit }, data) {
        commit('SET_ADDRESS_STATUS', data)
    },
}

const getters = {
    addressIsComplete: (state) => state.addressIsComplete,
    missingAddressParts: (state) => state.missingAddressParts,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
